import React, { useState, useRef, useEffect } from "react";
import { v4 as uuid } from "uuid";
import styles from "./rightPortion.css";

import { useSelector, useDispatch } from "react-redux";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import LinearProgress from "@mui/material/LinearProgress";
import { goToPage } from "../redux/pageSlice";
import Box from "@mui/material/Box";
import AnimatedProgressBar from "./animatedBar";
import CircularProgress from "@mui/material/CircularProgress";
import Loader from "./Loader";

const RightPortion = () => {
  useEffect(() => {
    document.addEventListener("dblclick", () => {
      console.log("unhighlight");
      unhighlight_values();
    });
    return () => {
      document.removeEventListener("dblclick", unhighlight_values);
    };
  }, []);

  const [awaiting, setAwaiting] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const chatboxRef = useRef(null);
  const [userColor] = useState("#2E7CF6"); // Input variable for sky blue hex code
  const [aiColor] = useState("#F0F0F0");
  const dispatch = useDispatch();

  const getSummary = async (userInput) => {
    const response = await fetch(
      "https://simplifai-ehr-backend-53e1e3227ba1.herokuapp.com/getPatientSummary",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userInput }),
      }
    );

    const data = await response.json();
    return data;
  };
  // This should handle the double clicking of the pageLinks
  const handleClick = (value) => (e) => {
    console.log("In handleClick with val: " + value);
    unhighlight_values(); // unhighlight values once any click was listened to
    switch (e.detail) {
      case 1:
        dispatch(goToPage(value)); // for one click, go to location in PDF
        dispatch(goToPage("1"));
      case 2:
        console.log("double"); // for two clicks, should print summary of packet
        dispatch(goToPage("1"));
        dispatch(goToPage(value)); // for one click, go to location in PDF
        break;
    }
  };

  useEffect(() => {
    const initializeChat = async () => {
      setAwaiting(true);
      try {
        const { message } = await getSummary(userInput);

        const initialMessage = {
          id: uuid(),
          content: `Hey there! I'm SimplifAI, your virtual assistant for electronic health records. How may I help you today?`,
          fromUser: false,
        };

        const summaryMessage = {
          id: uuid(),
          content: ` ${message}`,
          fromUser: false,
        };

        setMessages([initialMessage, summaryMessage]);
      } catch (error) {
        // Handle any errors that might occur during the API call
        console.error("Error fetching data:", error);
      }
      setAwaiting(false);
    };

    initializeChat();
  }, []); // Empty dependency array, runs only once on mount.

  var pageLinkList = [];
  const getPageLinkList = (pages) => {
    console.log("PAGES: " + pages);
    if (typeof pages !== typeof [1, 2, 3]) {
      console.log("ALWAYS HERE");
      pages = [pages];
    }
    pages.forEach((page) => {
      pageLinkList.push(page);
    });
    return pageLinkList;
  };
  var pageLinks = [];
  const getPageLinks = (pageLinkList) => {
    pageLinkList.forEach((pageLink) => {
      pageLinks.push(
        <button
          id={uuid()}
          style={{ color: "blue", margin: "0.25rem" }}
          onClick={handleClick(pageLink)}
        >
          {pageLink}
        </button>
      );
    });
    return pageLinks;
  };

  const handleTrigger = async () => {
    console.log("IN HANDLE TRIGGER");
    unhighlight_values();
    setTimeout(async () => {
      let value = document.getElementById("load_trigger_button").value;
      console.log("HERE IS THE VALUE" + String(value));
      const newMessage1 = {
        id: uuid(),
        content: (
          <>
            <p>{"Please summarise the following page(s): " + String(value)}</p>
          </>
        ),
        fromUser: true,
      };

      setMessages([...messages, newMessage1]);

      let test = await getTest();
      test = test[value];
      console.log(test);
      const messageOnly = {
        id: uuid(),
        content:
        (
          <>
            {"You have requested a summary for page(s) " + value + "!"}<br />
            <br />
            {test}
          </>
        ),
        fromUser: false,
      };
      let pages = value;
      if (pages !== null && (pages.length > 0 || !isNaN(parseInt(pages)))) {
        let pagesString;
        try {
          pagesString = pages.join(", ");
        } catch (error) {
          pagesString = String(pages);
        }
        highlight_value(pages);

        pages = pages.split(",");

        let pageLinkList = getPageLinkList(pages);
        let pageLinks = getPageLinks(pageLinkList);
        let content = <div id="l2"> Relevant Pages: {pageLinks} </div>;
        const pagesOnly = {
          id: uuid(),
          content: content,
          fromUser: false,
        };
        setMessages((prevMessages) => [
          ...prevMessages,
          messageOnly,
          pagesOnly,
        ]);
      } else {
        setMessages((prevMessages) => [...prevMessages, messageOnly]);
      }
    }, 0);
  };

  const handleSendMessage = async () => {
    console.log("IN HANDLE SEND MESSAGE");
    if (userInput.trim() !== "") {
      const newMessage = {
        id: uuid(),
        content: (
          <div className="ps-1 flex flex-row justify-around text-start pb-0">
            {/* <div className="ps-1 flex flex-row justify-around items-center"> */}
            <p className="">{userInput}</p>
            {/* <AnimatedProgressBar /> */}
          </div>
        ),
        fromUser: true,
      };
      unhighlight_values();
      const newMessageNoProgressBar = {
        id: uuid(),
        content: userInput,
        fromUser: true,
      };

      setMessages([...messages, newMessage]);
      setUserInput("");

      setTimeout(async () => {
        setAwaiting(true);
        let message =
          "Apologies, we ran into an OpenAI timeout error! Please try your query again. If the error persists, please change your prompt.";
        let pages = null;
        try {
          const promise = getPythonMessage(userInput);
          const timeout = new Promise((resolve, reject) => {
            setTimeout(() => {
              reject(new Error("Timeout"));
            }, 30000);
          });
          const result = await Promise.race([promise, timeout]);
          if (result instanceof Error) {
            // Handle timeout error
            console.log("Request timed out");
          } else {
            ({ message, pages } = result);
          }
        } catch (error) {
          // Handle any other errors that might occur during the API call
          console.error("Error fetching data:", error);
        }
        setAwaiting(false);

        const messageOnly = {
          id: uuid(),
          content: message.split('\n').map((line, index) => <React.Fragment key={index}>{line}<br /></React.Fragment>),
          fromUser: false,
        };
        let dropdownitems = document.querySelectorAll("[id*=drop]");
        let pages_by_category = [];
        dropdownitems.forEach((item) => {
          pages_by_category.push(String(item.id).split("dropdowntable")[1]);
        });

        let pages_to_be_highlighted = [];
        if (typeof pages != typeof [1, 2, 3]) {
          pages = [pages];
        }
        if (pages !== null && pages.length > 0) {
          pages.forEach((page) => {
            pages_by_category.forEach((page_by_category) => {
              let candidate = page_by_category.split(",");
              candidate.forEach((x) => {
                if (String(page) === x) {
                  pages_to_be_highlighted.push(page_by_category);
                } else {
                }
              });
            });
          });
        } else {
          pages_by_category.forEach((page_by_category) => {
            let candidate = page_by_category.split(",");
            candidate.forEach((x) => {
              if (String(pages) === x) {
                pages_to_be_highlighted.push(page_by_category);
              } else {
              }
            });
          });
        }
        pages_to_be_highlighted.forEach((page) => {
          highlight_value(page);
        });
        if (pages !== null && (pages.length > 0 || !isNaN(parseInt(pages)))) {
          let pagesString;
          try {
            pagesString = pages.join(", ");
          } catch (error) {
            pagesString = String(pages);
          }
          let pageLinkList = getPageLinkList(pages);
          let pageLinks = getPageLinks(pageLinkList);
          let content = <div id="l2"> Relevant Pages: {pageLinks} </div>;
          const pagesOnly = {
            id: uuid(),
            content: content,
            fromUser: false,
          };
          setMessages((prevMessages) => [
            ...prevMessages.slice(0, prevMessages.length - 1), // Remove the last message (newMessage)
            newMessageNoProgressBar, // Add newMessageNoProgressBar instead
            messageOnly,
            pagesOnly,
          ]);
        } else {
          setMessages((prevMessages) => [
            ...prevMessages.slice(0, prevMessages.length - 1), // Remove the last message (newMessage)
            newMessageNoProgressBar, // Add newMessageNoProgressBar instead
            messageOnly,
          ]);
        }
      }, 0);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && userInput.trim() !== "") {
      handleSendMessage();
    }
  };
  const getTest = async (page) => {
    const response = await fetch(
      "https://simplifai-ehr-backend-53e1e3227ba1.herokuapp.com/pageIndex",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {},
      }
    );

    const data = await response.json();
    console.log("HERE\n\n\n" + data);
    return data;
  };

  const getPythonMessage = async (userInput) => {
    const response = await fetch(
      "https://simplifai-ehr-backend-53e1e3227ba1.herokuapp.com/getPythonMessage",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userInput }),
      }
    );

    const data = await response.json();
    return data;
  };

  useEffect(() => {
    if (chatboxRef.current) {
      chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <>
      <div
        style={{
          paddingTop: "1%",
          paddingLeft: "1%",
          // paddingRight: "2%",
          width: "95%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "95%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <input
            type="text"
            value="SimplifAI Virtual Assistant"
            style={{
              width: "100%",
              textAlign: "center",
              fontSize: "26px",
              fontWeight: "bold",
              border: "none",
              outline: "none",
              backgroundColor: userColor,
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              borderRadius: "4px",
              padding: "8px",
              color: "white",
            }}
            readOnly
          />
        </div>

        <div
          ref={chatboxRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            overflowY: "scroll",
            height: "87vh",
            maxHeight: "82vh",
            width: "95%",
            maxWidth: "95%",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            paddingLeft: "3%",
            paddingRight: "3%",
          }}
        >
          {messages.map((message) => (
            <div
              key={message.id}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                backgroundColor: message.fromUser ? userColor : aiColor,
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "10px",
                paddingBottom: "10px",
                
                alignSelf: message.fromUser ? "flex-end" : "flex-start",
                // width: "75%",
                maxWidth: "75%",
                borderRadius: "4px",
                wordWrap: "break-word",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "start",
              }}
            >
              <p
                style={{
                  textAlign: "left",
                  backgroundColor: message.fromUser ? userColor : aiColor,
                  color: message.fromUser ? "white" : "black",
                  overflowWrap: "break-word",
                  overflowY: "auto",
                  height: "auto",
                  flex: "1",
                  // paddingLeft: "5px",
                  // paddingRight: "5px",
                  // paddingTop: "5px",
                  padding: "5px",
                  overflowX: "hidden",
                  width: "100%",
                  fontSize: "0.95rem",
                  margin: "0",
                }}
              >
                {message.content}
              </p>
            </div>
          ))}
          {awaiting && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                backgroundColor: aiColor,
                paddingRight: "3px",
                paddingLeft: "3px",
                alignSelf: "flex-start",
                width: "25%",
                height: "60px",
                maxWidth: "75%",
                borderRadius: "4px",
                wordWrap: "break-word",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* <CircularProgress
                sx={{ height: "10px", width: "10px", color: "blue" }}
              /> */}
              {awaiting && <Loader />}
            </div>
          )}
        </div>

        <div
          style={{
            width: "95%",
            display: "flex",
            height: "80px",
            paddingBottom: "5%",
          }}
        >
          <input
            id="input_form"
            type="text"
            placeholder={
              awaiting ? "Waiting for AI Assistant" : "Type your message"
            }
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyPress={handleKeyPress}
            style={{
              flex: "1",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              paddingRight: "10px",
              paddingLeft: "10px",
              borderRadius: "4px",
              backgroundColor: awaiting ? "#F0F0F0" : "inherit",
              height: "100%",
            }}
            disabled={awaiting}
          />

          <button
            id="send_button"
            style={{
              width: "100px",
              backgroundColor: userColor,
              fontWeight: "bold",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              paddingTop: "10px",
              paddingBottom: "10px",
              borderRadius: "4px",
              color: "white",
              height: "100%",
            }}
            onClick={handleSendMessage}
          >
            Send
          </button>
          <button
            hidden="true"
            id="load_trigger_button"
            onClick={handleTrigger}
          ></button>
          <button hidden={true} id="highlight_button" onClick={null}></button>
        </div>
      </div>
    </>
  );
};
// value should be a string, fn called by LHS table of contents
const pull_trigger = (value) => {
  console.log("in pull_trigger with val:" + value);
  let input_form = document.getElementById("input_form");
  let pull_trigger_button = document.getElementById("load_trigger_button");
  pull_trigger_button.value = value;
  pull_trigger_button.click();
};

// value should be a string, fn called whenever AI gives a response on relevant tabs on dropDown
const highlight_value = (value) => {
  console.log("INSIDE HIGHLIGHT VALUE", value);
  let dropdowntable = document.getElementById("dropdowntable" + value);
  //console.log(dropdowntable);
  //console.log(dropdowntable.style);
  dropdowntable.style.backgroundColor = "rgba(255, 255, 0, 0.45)";
  let highlight_button = document.getElementById("highlight_button");
  highlight_button.value += value + ".";
};

const highlight_values = () => {
  let highlight_button = document.getElementById("highlight_button");
  let todo_highlight = highlight_button.value.split(".");
  todo_highlight.forEach((todo) => {
    let dropdowntable = document.getElementById("dropdowntable" + todo);
    dropdowntable.style.backgroundColor = "rgba(255, 255, 0, 0.1)";
  });
};

const unhighlight_values = () => {
  console.log("UNHIGHLIGHTING");

  let highlight_button = document.getElementById("highlight_button");
  console.log(highlight_button);
  if (highlight_button.value == "") {
    return;
  } else {
    let todo_unhighlight = highlight_button.value.split(".");
    console.log(todo_unhighlight);
    todo_unhighlight.forEach((todo) => {
      if (todo === "") {
        console.log("empty todo for unhighlight");
      } else {
        let dropdowntable = document.getElementById("dropdowntable" + todo);
        console.log(dropdowntable);
        dropdowntable.style.backgroundColor = "#FFFFFF";
      }
    });
    highlight_button.value = "";
  }
};

export { pull_trigger };
//export {load_trigger};
export default RightPortion;
